export default __webpack_public_path__ + "static/media/access.af59e85d.svg";